import _getIterator from '/data/wwwroot/dongliyuanlin.com/web/node_modules/babel-runtime/core-js/get-iterator';

var files = require.context('@/middleware', false, /^\.\/(?!-)[^.]+\.(js)$/);
var filenames = files.keys();

function getModule(filename) {
  var file = files(filename);
  return file.default ? file.default : file;
}
var middleware = {};

// Generate the middleware
var _iteratorNormalCompletion = true;
var _didIteratorError = false;
var _iteratorError = undefined;

try {
  for (var _iterator = _getIterator(filenames), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
    var filename = _step.value;

    var name = filename.replace(/^\.\//, '').replace(/\.(js)$/, '');
    middleware[name] = getModule(filename);
  }
} catch (err) {
  _didIteratorError = true;
  _iteratorError = err;
} finally {
  try {
    if (!_iteratorNormalCompletion && _iterator.return) {
      _iterator.return();
    }
  } finally {
    if (_didIteratorError) {
      throw _iteratorError;
    }
  }
}

export default middleware;


//////////////////
// WEBPACK FOOTER
// ./.nuxt/middleware.js
// module id = ./.nuxt/middleware.js
// module chunks = 18